import { render, staticRenderFns } from "./PickupFilter.vue?vue&type=template&id=0c544461"
import script from "./PickupFilter.vue?vue&type=script&lang=js"
export * from "./PickupFilter.vue?vue&type=script&lang=js"
import style0 from "./PickupFilter.vue?vue&type=style&index=0&id=0c544461&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports